(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[866],{

/***/ 866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Cart; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Cart_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(835);
/* harmony import */ var _Cart_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Cart_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _context_CartContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5487);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_encrypting__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3735);










function Cart() {
    const { cart  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_CartContext__WEBPACK_IMPORTED_MODULE_3__/* .CartContext */ .A);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const [cartData, setCartData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const storedCart = localStorage.getItem("cart");
        if (storedCart) {
            const parsedCart = (0,_utils_encrypting__WEBPACK_IMPORTED_MODULE_6__/* .decryptData */ .o)(storedCart);
            setCartData(parsedCart);
        } else {
            setCartData([]); // Initialize with empty array if nothing is stored
        }
    }, []);
    const handleCartButtonClick = ()=>{
        router.push("/tickets/cart", undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Cart_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cart_main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
            onClick: handleCartButtonClick,
            className: (_Cart_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cart),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24px",
                    viewBox: "0 -960 960 960",
                    width: "24px",
                    fill: "#000000",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M240-80q-33 0-56.5-23.5T160-160v-480q0-33 23.5-56.5T240-720h80q0-66 47-113t113-47q66 0 113 47t47 113h80q33 0 56.5 23.5T800-640v480q0 33-23.5 56.5T720-80H240Zm0-80h480v-480h-80v80q0 17-11.5 28.5T600-520q-17 0-28.5-11.5T560-560v-80H400v80q0 17-11.5 28.5T360-520q-17 0-28.5-11.5T320-560v-80h-80v480Zm160-560h160q0-33-23.5-56.5T480-800q-33 0-56.5 23.5T400-720ZM240-160v-480 480Z"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Cart_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cart_items),
                    children: cart.length
                })
            ]
        })
    });
}


/***/ }),

/***/ 835:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cart_main":"Cart_cart_main__z9duX","cart":"Cart_cart__uKlLP","cart_items":"Cart_cart_items__SZq5Z"};

/***/ })

}]);